import { render, staticRenderFns } from "./FormDetailBasic.vue?vue&type=template&id=b975a96e&scoped=true&"
import script from "./FormDetailBasic.vue?vue&type=script&lang=js&"
export * from "./FormDetailBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b975a96e",
  null
  
)

export default component.exports